<template>
    <div class="training-portal">
        <app-overlay-loader v-if="preloader" />

        <div v-if="active === 1 && forms.length > 0" class="training-portal-content">
            <div class="training-portal-hero">
                <div>
                    <div class="training-portal-kicker">{{ $t('Learning Dashboard') }}</div>
                    <h3 class="training-portal-title">{{ $t('Start Your Training Journey') }}</h3>
                    <p class="training-portal-subtitle">
                        {{ $t('Track assigned modules, monitor completion, and open each form from a course-style overview.') }}
                    </p>
                </div>
                <div class="training-portal-stats">
                    <div class="training-stat-card">
                        <span class="training-stat-value">{{ totalModules }}</span>
                        <span class="training-stat-label">{{ $t('Modules') }}</span>
                    </div>
                    <div class="training-stat-card">
                        <span class="training-stat-value">{{ completedModules }}</span>
                        <span class="training-stat-label">{{ $t('Completed') }}</span>
                    </div>
                    <div class="training-stat-card">
                        <span class="training-stat-value">{{ overallCompletion }}%</span>
                        <span class="training-stat-label">{{ $t('Progress') }}</span>
                    </div>
                </div>
            </div>

            <div
                v-for="(formGroup, index) in forms"
                :key="formGroup.task.id"
                class="training-task-card"
            >
                <div class="training-task-header">
                    <div>
                        <div class="training-task-step">{{ $t('Training Path') }} {{ index + 1 }}</div>
                        <h4 class="training-task-title">{{ formGroup.task.title || `${$t('Task')} ${index + 1}` }}</h4>
                        <p class="training-task-meta">
                            {{ getCompletedCount(formGroup) }}/{{ getModuleCount(formGroup) }} {{ $t('modules completed') }}
                        </p>
                    </div>
                    <div class="training-task-progress">
                        <div class="training-task-progress-bar">
                            <div
                                class="training-task-progress-fill"
                                :style="{ width: `${Math.round(Number(formGroup.overallProgress || 0))}%` }"
                            ></div>
                        </div>
                        <span class="training-task-progress-text">{{ Math.round(Number(formGroup.overallProgress || 0)) }}%</span>
                    </div>
                </div>

                <div class="training-module-list">
                    <div
                        v-for="module in formGroup.task.task_forms_list"
                        :key="module.id"
                        class="training-module-card"
                    >
                        <div class="training-module-main">
                            <div class="training-module-badge" :class="getModuleStatusClass(module.response_status)">
                                {{ getModuleStatusLabel(module.response_status) }}
                            </div>
                            <div class="training-module-copy">
                                <h5 class="training-module-title">{{ module.title }}</h5>
                                <p class="training-module-description">{{ module.description || $t('Complete this module to move forward in the training workflow.') }}</p>
                            </div>
                        </div>

                        <div class="training-module-side">
                            <div class="training-module-percent">
                                {{ getModuleProgress(formGroup, module.id) }}%
                            </div>
                            <button
                                type="button"
                                class="btn btn-primary btn-sm"
                                @click="openModule(formGroup.task.id, module)"
                            >
                                {{ $t('Open Module') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="active === 2" class="training-task-detail">
            <div class="mb-3">
                <a href="" class="text-primary" @click.prevent="previous">{{ $t('Back to modules') }}</a>
            </div>
            <form-preview
                :id="selectedFormBodyId"
                :response="'save_response'"
                :form_id="selectedFormId"
                :form_revision_id="selectedFormRevisionId"
                :taskId="selectedTaskId"
            ></form-preview>
        </div>

        <div v-if="active === 1 && showEmpty">
            <app-empty-data-block :message="$t('nothing_to_show_message')"/>
        </div>
    </div>
  </template>
  
  <script>
  import { TRAINING_REQUEST_TASTS_FORMS } from "../../../Config/ApiUrl";
  import { axiosGet } from "../../../Helpers/AxiosHelper";
  
  export default {
    name: "mytaskmodal",
    props: {
        certificate_id: {type: Number, default: null},
        url: {type: String, default: ''}
    },
    data() {
      return {
        preloader: true,
        showEmpty: false,
        active: 1,
        selectedTaskId: 0,
        selectedFormBodyId: 0,
        selectedFormId: 0,
        selectedFormRevisionId: 0,
        actionType: true,
        task_id: 0,
        overallProgress: 0,
        formProgress: {},
        taskForms: [],
        show: false,
        forms: [],
      };
    },
  
    methods: {
      getTask() {
        const requestUrl = this.url || (TRAINING_REQUEST_TASTS_FORMS + "/" + this.certificate_id);
        axiosGet(requestUrl)
          .then((response) => {
            this.forms = response.data;
            if (this.forms.length == 0) {
                this.showEmpty = true;
            }
            this.preloader = false;
          })
          .catch((error) => {
            
          });
      },
      getModuleCount(formGroup) {
        return formGroup?.task?.task_forms_list?.length || 0;
      },
      getCompletedCount(formGroup) {
        return (formGroup?.task?.task_forms_list || []).filter((module) =>
          ["submitted", "completed", "in review"].includes((module.response_status || "").toLowerCase())
        ).length;
      },
      getModuleProgress(formGroup, moduleId) {
        const rawValue = Number(formGroup?.formsProgress?.[moduleId] || 0);
        return Math.round(rawValue);
      },
      getModuleStatusLabel(status) {
        const normalized = (status || "not submitted").toLowerCase();
        if (normalized === "submitted") return this.$t("Completed");
        if (normalized === "in review") return this.$t("In Review");
        if (normalized === "completed") return this.$t("Completed");
        return this.$t("Pending");
      },
      getModuleStatusClass(status) {
        const normalized = (status || "not submitted").toLowerCase();
        if (normalized === "submitted" || normalized === "completed") return "is-complete";
        if (normalized === "in review") return "is-review";
        return "is-pending";
      },
      openModule(taskId, module) {
        this.$store.commit('updateSharedData', {index: "taskId", newValue: taskId});
        this.selectedTaskId = taskId;
        this.selectedFormBodyId = module.form_body_id;
        this.selectedFormId = module.form_id;
        this.selectedFormRevisionId = module.id;
        this.active = 2;
      },
      previous() {
        this.active = 1;
        this.selectedTaskId = 0;
        this.selectedFormBodyId = 0;
        this.selectedFormId = 0;
        this.selectedFormRevisionId = 0;
      },
    },
    mounted() {
      this.getTask();
    },
    computed: {
      userRole() {
        return this.$store.state.user.loggedInUser;
      },
      userId() {
        return this.$store.state.user.loggedInUser.id;
      },
      totalModules() {
        return this.forms.reduce((total, formGroup) => total + this.getModuleCount(formGroup), 0);
      },
      completedModules() {
        return this.forms.reduce((total, formGroup) => total + this.getCompletedCount(formGroup), 0);
      },
      overallCompletion() {
        if (!this.totalModules) return 0;
        return Math.round((this.completedModules / this.totalModules) * 100);
      }
    },
  };
  </script>

<style scoped>
.training-portal {
  position: relative;
  min-height: 220px;
}

.training-portal-content {
  display: grid;
  gap: 1.5rem;
}

.training-portal-hero {
  display: flex;
  justify-content: space-between;
  gap: 1.5rem;
  padding: 1.75rem;
  border-radius: 20px;
  background: linear-gradient(135deg, #0f1f4d 0%, #1f4c7a 100%);
  color: #fff;
}

.training-portal-kicker {
  font-size: 0.78rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  opacity: 0.78;
  margin-bottom: 0.4rem;
}

.training-portal-title {
  margin: 0 0 0.5rem;
  font-size: 2rem;
  line-height: 1.15;
}

.training-portal-subtitle {
  margin: 0;
  max-width: 680px;
  color: rgba(255, 255, 255, 0.82);
}

.training-portal-stats {
  display: flex;
  gap: 1rem;
  align-items: stretch;
}

.training-stat-card {
  min-width: 120px;
  padding: 1rem;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(4px);
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.training-stat-value {
  font-size: 1.6rem;
  font-weight: 700;
}

.training-stat-label {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.75);
}

.training-task-card {
  background: #fff;
  border: 1px solid #e6ebf2;
  border-radius: 18px;
  padding: 1.5rem;
  box-shadow: 0 10px 24px rgba(21, 33, 61, 0.06);
}

.training-task-header {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: center;
  margin-bottom: 1.25rem;
}

.training-task-step {
  font-size: 0.78rem;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #68758a;
  margin-bottom: 0.35rem;
}

.training-task-title {
  margin: 0 0 0.35rem;
  font-size: 1.35rem;
  color: #1e2a3b;
}

.training-task-meta {
  margin: 0;
  color: #6b7788;
}

.training-task-progress {
  min-width: 180px;
}

.training-task-progress-bar {
  height: 10px;
  border-radius: 999px;
  background: #e9edf4;
  overflow: hidden;
  margin-bottom: 0.4rem;
}

.training-task-progress-fill {
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, #17a2b8 0%, #39c27f 100%);
}

.training-task-progress-text {
  font-size: 0.88rem;
  color: #5e6c80;
}

.training-module-list {
  display: grid;
  gap: 0.9rem;
}

.training-module-card {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: center;
  padding: 1rem 1.1rem;
  border-radius: 14px;
  background: #f8fafc;
  border: 1px solid #edf1f5;
}

.training-module-main {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
  flex: 1;
}

.training-module-badge {
  min-width: 96px;
  text-align: center;
  padding: 0.45rem 0.65rem;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 700;
}

.training-module-badge.is-complete {
  background: #e8f8ef;
  color: #1d8f55;
}

.training-module-badge.is-review {
  background: #fff4db;
  color: #b7791f;
}

.training-module-badge.is-pending {
  background: #eef2f7;
  color: #607086;
}

.training-module-copy {
  flex: 1;
}

.training-module-title {
  margin: 0 0 0.35rem;
  font-size: 1rem;
  color: #1e2a3b;
}

.training-module-description {
  margin: 0;
  color: #647286;
  font-size: 0.92rem;
  line-height: 1.6;
}

.training-module-side {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.65rem;
}

.training-module-percent {
  font-size: 1.1rem;
  font-weight: 700;
  color: #1c355e;
}
</style>
  
